import React from 'react';
import { Heading, Logo, Paragraph } from '@landr/maestro';
import { Trans } from '@lingui/macro';
import DescriptiveSection from '../DescriptiveSection/DescriptiveSection';
import OneCreditOneSample from '../OneCreditOneSample/OneCreditOneSample';

const DescriptiveFreeUpsell = () => (
    <DescriptiveSection>
        <Logo variant="brand" color="neutral.50" mb="xxl" />
        <Heading as="h2">
            <Trans>Unlock 2 million exclusive and curated samples</Trans>
        </Heading>
        <OneCreditOneSample />
        <Paragraph>
            <Trans>
                Don’t miss out on royalty-free sounds from today’s best artists,
                producers and labels.
            </Trans>
        </Paragraph>
    </DescriptiveSection>
);

export default DescriptiveFreeUpsell;
